import { Stack } from '@astryxdesign/core/Stack'
import { Card } from '@astryxdesign/core/Card'
import { Text } from '@astryxdesign/core/Text'
import { Button } from '@astryxdesign/core/Button'
import { Logo } from '#/components/Logo'

/**
 * What a visitor with no credential sees.
 *
 * There are two ways in and they look nothing alike, so the screen says both
 * rather than offering one button and leaving the other half of the party
 * wondering why it does not work for them.
 */
export function SignedOut() {
  return (
    <Stack direction="vertical" gap={4} padding={4}>
      {/* The one screen with room for the mark at its full size. It is also
          the only screen a stranger ever sees, so it is worth signing. */}
      <Stack direction="vertical" gap={2} paddingBlockStart={4}>
        <Logo size={72} title="Travel" />
        <Stack direction="vertical" gap={1}>
          <Text type="display-3" display="block">Travel</Text>
          <Text type="supporting">You are not signed in.</Text>
        </Stack>
      </Stack>

      <Card>
        <Stack direction="vertical" gap={3}>
          <Text weight="medium">Travelling with us?</Text>
          <Text type="supporting">
            Open the link you were sent. It signs you in as yourself and stays
            signed in — there is nothing to remember and no password.
          </Text>
        </Stack>
      </Card>

      <Card variant="muted">
        <Stack direction="vertical" gap={3}>
          <Text weight="medium">Organising the trip?</Text>
          <Text type="supporting">
            Sign in with the email address that was added to Cloudflare Access.
            You will get a one-time code by email.
          </Text>
          <Button
            label="Sign in with email"
            variant="primary"
            width="100%"
            href="/admin-login"
          />
        </Stack>
      </Card>
    </Stack>
  )
}
